import * as Yup from 'yup';

import { actionTakenValidation } from '../fields/ActionTakenField';
import { assigneeIdValidation } from '../fields/AssigneeIdField';
import { classificationIdValidation } from '../fields/ClassificationIdField';
import { descriptionValidation } from '../fields/DescriptionField';
import { followupValidation } from '../fields/FollowupField';
import { impactedUserIdsValidation } from '../fields/ImpactedUserIdsField';
import { incidentDateValidation } from '../fields/IncidentDateField';
import { kustomerUrlValidation } from '../fields/KustomerUrlField';
import { offenderIdValidation } from '../fields/OffenderIdField';
import { offenderTypeValidation } from '../fields/OffenderTypeField';
import { reportedOnValidation } from '../fields/ReportedOnField';

export const editIncidentValidationSchema = Yup.object().shape({
  reportedOn: reportedOnValidation,
  incidentDate: incidentDateValidation,
  description: descriptionValidation,
  kustomerUrl: kustomerUrlValidation,
  assigneeId: assigneeIdValidation,
  offenderType: offenderTypeValidation,
  classificationId: classificationIdValidation,
  offenderId: offenderIdValidation,
  impactedUserIds: impactedUserIdsValidation,
  followUps: followupValidation,
  actionTaken: actionTakenValidation,
});
